import { Link } from "react-router-dom";
import { clsx } from "clsx";

function LogoMark() {
  return (
    <span className="mr-3 flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-brand bg-brand-background shadow-soft">
      <svg viewBox="0 0 256 256" className="h-10 w-10" aria-hidden="true">
        <rect width="256" height="256" rx="56" fill="#F7F1E8" />
        <circle cx="188" cy="68" r="28" fill="#F08A24" />
        <path fill="#2B2B2B" d="M55 181 105 55h31l50 126h-29l-10-28H93l-10 28H55Zm46-51h38l-19-53-19 53Z" />
      </svg>
    </span>
  );
}

export function Logo({ compact = false, className }: { compact?: boolean; className?: string }) {
  return (
    <Link
      to="/"
      className={clsx("focus-ring inline-flex min-w-0 items-center rounded-brand text-lg font-black", className)}
      aria-label="aladdinshenewa.online home"
    >
      <LogoMark />
      {!compact ? (
        <span className="truncate tracking-normal">
          <span className="text-brand-text">aladdinshenewa</span>
          <span className="text-brand-accent">.online</span>
        </span>
      ) : (
        <span className="tracking-normal">
          <span className="text-brand-text">aladdin</span>
          <span className="text-brand-accent">.online</span>
        </span>
      )}
    </Link>
  );
}
